import React, { Component } from 'react';
import Report from './Report'

export const FullPageReport = (props) => (
    <div className="container" style={{ marginTop: '4em', marginBottom: '4em'}}>
        <Report {...props} />
    </div>
)


// WEBPACK FOOTER //
// ./src/FullPageReport.jsx